import React from 'react';
import ErrorPage from '../modules/ErrorPage';

function Error(){
  return <ErrorPage/>
}

export default Error;